import React, { useState } from "react";
import Refresh from "@mui/icons-material/Refresh";
import { IconButton } from "@mui/material";
import { CasLoader } from "../../brand/CasLoader";
import { useFetchNotebookPage, useGetNotebookPage } from "../../../hook/page";
import {
  useFetchFolderPropertyTypes,
  useFetchPagePropertyValues,
} from "../../../hook/page/property";
import { useIncrementSubscriptionRefresh } from "../../../hook/page/block/subscription";
import { useFetchPagePropsCallback } from "../../../hook/page/pageProp";

export const RefreshPageButton: React.FC<{ pageId: string | undefined }> = ({
  pageId,
}) => {
  const fetchNotebookPage = useFetchNotebookPage(pageId);
  const [isLoading, setIsLoading] = useState(false);
  const fetchPageProperties = useFetchFolderPropertyTypes();
  const fetchPagePropertyValues = useFetchPagePropertyValues();
  const getPage = useGetNotebookPage();
  const folderId = getPage(pageId)?.["folder-id"];
  const incrementSubscriptionRefresh = useIncrementSubscriptionRefresh();
  const fetchPageProps = useFetchPagePropsCallback();

  return (
    <>
      {isLoading && <CasLoader size={20} />}
      <IconButton
        sx={{ height: 20 }}
        color="primary"
        disabled={isLoading || !pageId}
        onClick={() => {
          if (!pageId) return;
          if (!folderId) return;
          setIsLoading(true);
          incrementSubscriptionRefresh();
          const fetchPagePromise = fetchNotebookPage();
          const fetchPropsPromise = fetchPageProperties(pageId);
          const fetchPropValsPromise = fetchPagePropertyValues();
          Promise.all([
            fetchPagePromise,
            fetchPropsPromise,
            fetchPropValsPromise,
            pageId ? fetchPageProps(pageId) : Promise.resolve(),
          ]).then(() => {
            setIsLoading(false);
          });
        }}
      >
        <Refresh />
      </IconButton>
    </>
  );
};
